import EmptyState from 'components/emptyState';
import { useTranslation } from 'react-i18next';

export function ImportSectionsDialogEmptySearchResults() {
  const { t } = useTranslation();

  return (
    <EmptyState
      headerText={t('editor.sections.search_empty_results')}
      supportingText={t('editor.sections.search_empty_results_description')}
    />
  );
}
